"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var mapConfig = {
  initialView: {
    center: {
      lat: 41.765744,
      lng: -89.099345
    },
    zoom: 8
  },
  allowedBBox: {
    south: 39.287148,
    west: -90.623134,
    north: 43.821787,
    east: -86.157022
  },
  minZoom: 8,
  maxZoom: 16,
  defaultLayer: []
};
var _default = mapConfig;
exports.default = _default;